// @flow

import React, { Component } from "react";
import { localize } from "redux-i18n";

import { Button, Text, View } from "../../index";
import ImageLibraryPickerModal from "./image-library-picker-modal";
import type { ImageLibraryItem } from "@modules/management/types";

type Props = {
  value?: string | null,
  disabled?: boolean,
  readonly?: boolean,
  onChange: (value: string | null) => void,
  ...PropsFromLocalize,
};

type ComponentState = {
  isOpen: boolean,
  previewFailed: boolean,
};

class ImageLibraryPickerWidget extends Component<Props, ComponentState> {
  state = {
    isOpen: false,
    previewFailed: false,
  };

  showModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  handleSelect = (image: ImageLibraryItem) => {
    this.props.onChange(image.url);
    this.setState({ isOpen: false, previewFailed: false });
  };

  render() {
    const { t, value, disabled, readonly } = this.props;

    return (
      <React.Fragment>
        <View direction="column" alignItems="flex-start" gap={2}>
          {value &&
            (!this.state.previewFailed ? (
              <img
                className="image-library-picker-preview"
                src={value}
                alt=""
                onError={() => this.setState({ previewFailed: true })}
              />
            ) : (
              <Text type="p" text={value} />
            ))}
          <Button
            type="button"
            color="primary"
            disabled={disabled || readonly}
            onClick={this.showModal}
            label={value ? t("CHANGE_IMAGE") : t("SELECT_IMAGE")}
          />
        </View>
        {this.state.isOpen && (
          <ImageLibraryPickerModal onCancel={this.closeModal} onSelect={this.handleSelect} />
        )}
      </React.Fragment>
    );
  }
}

export default localize()(ImageLibraryPickerWidget);
